module.exports = __webpack_public_path__ + "img/lippu_ja_tunnuslause-uai-516x81.b9b5ca42.jpg";